import { useEffect, useState, type ReactNode } from 'react'
import { api } from './client'
import { HealthCtx, type HealthState } from './health-state'

export function HealthProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<HealthState>({ health: null, loading: true, error: null })
  useEffect(() => {
    let live = true
    api.health()
      .then((h) => { if (live) setState({ health: h, loading: false, error: null }) })
      .catch((e) => { if (live) setState({ health: null, loading: false, error: String(e) }) })
    return () => { live = false }
  }, [])
  return <HealthCtx.Provider value={state}>{children}</HealthCtx.Provider>
}
